export enum BLOB_UPLOAD_TYPE {
  DANCE_SCHOOL_LOGO = "DanceSchoolLogo",
  DANCE_SCHOOL_TERMS_AND_CONDITIONS = "DanceSchoolTermsAndConditions",
  DANCE_SCHOOL_EMAIL_ATTACHMENT = "DanceSchoolEmailAttachment"
}

export interface IPreSignedBlobUrl {
  key: string;
  fileName: string;
  signedUrl: string;
  metadata: Record<string, string>;
}

export interface ICreateBlobUploadLinkRequest {
  uploadType: BLOB_UPLOAD_TYPE;
  fileName: string;
  contentType: string;
}